import { useState } from "react";

import type {
  AudienceProfile,
  AudienceProfileState,
  CancelledTarget,
  CancelledTargetState,
} from "../types";

//this is the hook used in campaign details audience
export default function useCampaignDetailsAudience(
  audience: AudienceProfile[],
  cancelledAudience: CancelledTarget[],
) {
  const [searchText, setSearchText] = useState("");
  const [selectedStates, setSelectedStates] = useState<
    (AudienceProfileState | CancelledTargetState)[]
  >([]);

  function resetFilters() {
    setSelectedStates([]);
    setSearchText("");
  }

  const audienceWithCancellation = audience
    ? audience.map((target) => {
        const cancellationDetails = cancelledAudience?.find(
          ({ target_urn }) => target.urn === target_urn,
        );
        return { ...target, cancellationDetails };
      })
    : [];

  const filteredTargets = audienceWithCancellation.filter(
    ({ full_name, state, cancellationDetails }) => {
      const lowercasedInput = searchText.toLowerCase();

      const isMatchingInput = lowercasedInput
        ? full_name.toLowerCase().includes(lowercasedInput)
        : true;

      let isMatchingState = true;
      if (selectedStates.length) {
        isMatchingState =
          selectedStates.includes(state) ||
          selectedStates.includes(cancellationDetails?.transition);
      }

      return isMatchingInput && isMatchingState;
    },
  );

  return {
    searchText,
    setSearchText,
    selectedStates,
    setSelectedStates,
    resetFilters,
    filteredTargets,
    audienceWithCancellation,
  };
}
